import React from 'react'
import SettingsEmailForm from '../components/setting/settingsEmailForm'

const SettingsEmail = () => {
  return (
    <><SettingsEmailForm/></>
  )
}

export default SettingsEmail